import React, { useState } from "react";
import { Box, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Button, MenuItem, Select, Typography, Container } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs"; // For date filtering
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

const ExpenseList = ({ expenses, deleteExpense }) => {
    const navigate = useNavigate();
    const [filter, setFilter] = useState("all");

    const [pricePerLitre, setPricePerLitre] = useState("");
    const [totalExpense, setTotalExpense] = useState(0);

    const calculateExpense = () => {
        const totalLitres = filteredExpenses.reduce((acc, curr) => acc + (curr.unit === "Litre" ? curr.quantity : curr.quantity / 1000), 0);
        setTotalExpense(totalLitres * parseFloat(pricePerLitre));
    };

    // Get today's date
    const today = dayjs();
    const startOfWeek = today.startOf("week");
    const startOfMonth = today.startOf("month");
    const startOfLastMonth = today.subtract(1, "month").startOf("month");
    const endOfLastMonth = today.subtract(1, "month").endOf("month");

    // Function to filter expenses
    const filteredExpenses = expenses.filter((expense) => {
        const expenseDate = dayjs(expense.date);
        if (filter === "thisWeek") return expenseDate.isBetween(startOfWeek, today, null, "[]");
        if (filter === "thisMonth") return expenseDate.isBetween(startOfMonth, today, null, "[]");
        if (filter === "lastMonth") return expenseDate.isBetween(startOfLastMonth, endOfLastMonth, null, "[]");
        return true; // "all"
    });

    return (
        <Container sx={{ marginTop: 6 }}>
            <Typography variant="h5" sx={{ color: "#0d0127", textAlign: "left", marginBottom: 2 }}>
                MEM - Milk Expense Manager
            </Typography>
            <Typography variant="h5" sx={{ color: "#003366", textAlign: "center", marginBottom: 2 }}>
                Expense List
            </Typography>

            

            {/* Filter Dropdown */}
            <Select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                sx={{ marginBottom: 2, width: "100%", color: "black" }}
            >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="thisWeek">This Week</MenuItem>
                <MenuItem value="thisMonth">This Month</MenuItem>
                <MenuItem value="lastMonth">Last Month</MenuItem>
            </Select>

            {/* Expense Table */}
            {filteredExpenses.length === 0 ? (
                <Typography variant="h6" sx={{ textAlign: "center", marginTop: 2 }}>No expenses found.</Typography>
            ) : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "#081749" }}>
                            <TableRow>
                                <TableCell sx={{ color: "white",backgroundColor: "#081749"  }}>Date</TableCell>
                                <TableCell sx={{ color: "white",backgroundColor: "#081749" }}>Time</TableCell>
                                <TableCell sx={{ color: "white",backgroundColor: "#081749" }}>Quantity (Litres)</TableCell>
                                <TableCell sx={{ color: "white",backgroundColor: "#081749" }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredExpenses.map((expense, index) => (
                                <TableRow key={index}>
                                    <TableCell>{expense.date}</TableCell>
                                    <TableCell>{expense.time}</TableCell>
                                    <TableCell>{expense.quantity} L</TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => deleteExpense(index)} sx={{ color: "red" }}>
                                            <Delete />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {/* Add Expense Button */}
            <Box sx={{ display: 'flex', gap: 3 }} marginTop={2}>


            <TextField
                label="Price per Litre"
                type="number"
                fullWidth
                margin="normal"
                value={pricePerLitre}
                onChange={(e) => setPricePerLitre(e.target.value)}
            />

            {totalExpense !== null && (
                <Typography variant="p" marginTop={4}>
                ₹{totalExpense.toFixed(2)}
                </Typography>
            )}
            <Button variant="contained" color="primary" fullWidth sx={{ height: 50, marginTop: 3 }} onClick={calculateExpense}>
                Calculate
            </Button>
            </Box>
        </Container>
    );
};

export default ExpenseList;
